const routes = [
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "intro" */ '@/layouts/Intro.vue'),
    children: [
      {
        path: 'login',
        meta: { anonymous: true },
        component: () =>
          import(/* webpackChunkName: "intro" */ '@/views/login/LoginPage.vue'),
      },
      {
        /* KB 관리자 자동 가입 및 로그인 -> 대시보드로 이동
          아래 예시와 같은 형태로 진입  
          예시: {{url}}/mas/kb?userId={{userId}}&userName={{userName}}
         */
        path: 'kb',
        meta: { anonymous: true },
        component: () =>
          import(
            /* webpackChunkName: "intro" */ '@/views/login/SsoLoginPage.vue'
          ),
      },
    ],
  },
];

export default routes;
